import { createSlice } from "@reduxjs/toolkit";

const payrollSlice = createSlice({
  name: "payroll",
  initialState: {
    isLoading: false,
    isLoadingPage: false,
    incomeDeductionList: [],
    currentIncomeDeduction: {},
    welfareList: [],
    currentWelfare: {},
    payrollPeriodList: [],
    employmentTypeOption: [],
    startPeriodOnFlowHr: [],
    specialPeriodOption: [],
    incomeForSpecialPeriod: [],
    deductionForSpecialPeriod: [],
    payrollPeriodListPage: [],
    payrollPerMonth: [],
    payrollPeriodCalculateDetails: []
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsLoadingPage(state, action) {
      state.isLoadingPage = action.payload;
    },
    setIncomeDeductionList(state, action) {
      state.incomeDeductionList = action.payload;
    },
    setCurrentIncomeDeduction(state, action) {
      state.currentIncomeDeduction = action.payload;
    },
    setWelfaleList(state, action) {
      state.welfareList = action.payload;
    },
    setCurrentWelfare(state, action) {
      state.currentWelfare = action.payload;
    },
    setPayrollPeriodList(state, action) {
      state.payrollPeriodList = action.payload;
    },
    setPayrollPeriodListPage(state, action) {
      state.payrollPeriodListPage = action.payload;
    },
    setEmploymentTypeOption(state, action) {
      state.employmentTypeOption = action.payload;
    },
    setStartPeriodOnFlowHr(state, action) {
      state.startPeriodOnFlowHr = action.payload;
    },
    setSpecialPeriodDropdown(state, action) {
      state.specialPeriodOption = action.payload;
    },
    setIncomeForSpecialPeriod(state, action) {
      state.incomeForSpecialPeriod = action.payload;
    },
    setDeductionForSpecialPeriod(state, action) {
      state.deductionForSpecialPeriod = action.payload;
    },
    setPayrollPerMonth(state, action) {
      state.payrollPerMonth = action.payload;
    },
    setPayrollPeriodCalculateDetails(state, action) {
      state.payrollPeriodCalculateDetails = action.payload;
    }


  },
});

export const {
  setIsLoading,
  setIsLoadingPage,
  setIncomeDeductionList,
  setCurrentIncomeDeduction,
  setWelfaleList,
  setCurrentWelfare,
  setPayrollPeriodList,
  setPayrollPeriodListPage,
  setEmploymentTypeOption,
  setStartPeriodOnFlowHr,
  setSpecialPeriodDropdown,
  setIncomeForSpecialPeriod,
  setDeductionForSpecialPeriod,
  setPayrollPerMonth,
  setPayrollPeriodCalculateDetails
} = payrollSlice.actions;
export default payrollSlice.reducer;
